'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'business-time';
var width = 640;
var height = 512;
var aliases = ["briefcase-clock"];
var unicode = 'f64a';
var svgPathData = ['M80 160c0-26.5 21.5-48 48-48l384 0c26.5 0 48 21.5 48 48l0 58.9c-20-7.1-41.6-10.9-64-10.9-48.7 0-93.2 18.1-127 48l-289 0 0-96zm0 112l176 0 0 32c0 17.7 14.3 32 32 32l26.9 0c-7.1 20-10.9 41.6-10.9 64s3.8 44 10.9 64L128 464c-26.5 0-48-21.5-48-48l0-144z', 'M264 16l112 0c13.3 0 24 10.7 24 24l0 56-160 0 0-56c0-13.3 10.7-24 24-24zM224 40l0 56-96 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l193.4 0c-2.4-5.2-4.6-10.6-6.5-16L128 464c-26.5 0-48-21.5-48-48l0-144 176 0 0 32c0 17.7 14.3 32 32 32l26.9 0c1.9-5.4 4.1-10.8 6.5-16L288 320c-8.8 0-16-7.2-16-16l0-32 80.9 0c5-5.6 10.4-11 16.1-16l-289 0 0-96c0-26.5 21.5-48 48-48l384 0c26.5 0 48 21.5 48 48l0 58.9c5.4 1.9 10.8 4.1 16 6.5l0-65.4c0-35.3-28.7-64-64-64l-96 0 0-56c0-22.1-17.9-40-40-40L264 0c-22.1 0-40 17.9-40 40zM496 272a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-4.4 0-8 3.6-8 8l0 72c0 4.4 3.6 8 8 8l56 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-48 0 0-64c0-4.4-3.6-8-8-8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBusinessTime = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;